import ReviewObservationRepository from "@/repositories/ReviewObservationRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'reviewObservation',
    namespaced: true,
    state: {
        ...makeState()
    },
    getters: {
        ...makeGetters()
    },
    mutations: {
        ...makeMutations()
    },
    actions: {
        async listAll({commit, state}, params) {
            commit('setLoading', true)
            await ReviewObservationRepository.listAll({...params, ...state.pagination})
                .then(response => {
                    commit('setPagination', {
                        page: response.data.current_page,
                        per_page: response.data.per_page,
                        total: response.data.total
                    })
                    commit('setAll', response.data.data)
                }).catch(console.error)
            commit('setLoading', false)
        },
        async listOne({commit, state}, id) {
            commit('setLoading', true)
            await ReviewObservationRepository.listOne(id)
                .then(response => {
                    const current = response.data
                    if (current instanceof Array) {
                        commit('setCurrent', [])
                        current.map(reviewObservation => {
                            const obj = {...reviewObservation}
                            commit('setCurrent', [...state.current, obj])
                        })
                    }

                    if (!(current instanceof Array)) {
                        commit('setCurrent', {...response.data})
                    }
                })

            commit('setLoading', false)
        },
        async listNext({commit, state}) {
            commit('setLoading', true)
            await ReviewObservationRepository.listNext()
                .then(response => {
                    const current = response.data
                    if (current instanceof Array) {
                        commit('setCurrent', [])
                        current.map(reviewObservation => {
                            const obj = {...reviewObservation}
                            commit('setCurrent', [...state.current, obj])
                        })
                    }

                    if (!(current instanceof Array)) {
                        commit('setCurrent', {...response.data})
                    }
                })

            commit('setLoading', false)
        }
    }
}
